// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ylLm","col":"styles_col__3i3bX"};